import ErrorPage from 'next/error'
import { useRouter } from 'next/router'

import { getImageUrl } from '@/api/sanity-image'
import Article from '@/components/Article'
import NavList from '@/components/NavList'
import SanityPreview from '@/components/SanityPreview'
import SEO from '@/components/SEO'
import useColor from '@/hooks/useColor'
import { buildGetStaticPaths, buildGetStaticProps } from '@/lib/page'
import { articleBySlugQuery } from '@/queries/article'
import type { ArticleBySlugQueryResult } from '../../../sanity.types'

const query = articleBySlugQuery

export default function Page({
  preview,
  pageData,
  error,
  status,
  slug,
}: SanityPageProps<ArticleBySlugQueryResult, { slug: string; status: string }>) {
  const router = useRouter()
  useColor(null, status)

  if (error) {
    return <ErrorPage statusCode={error.statusCode} title={error.title} />
  }

  if (!router.isFallback && !pageData) {
    return <ErrorPage statusCode={404} />
  }

  return (
    <SanityPreview preview={preview} initialData={pageData} query={query} params={{ slug }}>
      {(article) => {
        return (
          <div>
            <SEO
              title={article?.title}
              description={article?.preamble}
              path={`artikkel/${article?.slug?.current}`}
              image={article?.ogImages?.facebook && getImageUrl(article?.ogImages?.facebook).url()}
              excludeFromSearch={article?.excludeFromSearch}
            />
            <NavList
              back={
                article?.backLink
                  ? { href: article?.backLink, title: 'Tilbake' }
                  : { title: 'Hjem', href: '/' }
              }
            />
            <Article
              title={article?.title || ''}
              preamble={article?.preamble}
              image={article?.image}
              text={article?.text ?? undefined}
              publishedAt={article?.publishedAt ?? undefined}
              updatedAt={article?.updatedAt ?? undefined}
              author={article?.author}
              loanArticle={article?.loanArticle ?? undefined}
            />
          </div>
        )
      }}
    </SanityPreview>
  )
}

export const getStaticProps = buildGetStaticProps<ArticleBySlugQueryResult>(articleBySlugQuery)

export const getStaticPaths = buildGetStaticPaths('article')
